'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _components = require('components');

var _InputValueEditor = require('./InputValueEditor.css');

var _InputValueEditor2 = _interopRequireDefault(_InputValueEditor);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var InputValueEditor = function (_Component) {
  (0, _inherits3.default)(InputValueEditor, _Component);

  function InputValueEditor(props) {
    (0, _classCallCheck3.default)(this, InputValueEditor);

    var _this = (0, _possibleConstructorReturn3.default)(this, (InputValueEditor.__proto__ || (0, _getPrototypeOf2.default)(InputValueEditor)).call(this, props));

    _this.handleChange = _this.handleChange.bind(_this);
    return _this;
  }

  (0, _createClass3.default)(InputValueEditor, [{
    key: 'handleChange',
    value: function handleChange(e) {
      var _props = this.props,
          id = _props.id,
          updateInputValue = _props.updateInputValue;

      updateInputValue(id, e.target.value);
    }
  }, {
    key: 'render',
    value: function render() {
      var value = this.props.value;

      return _react2.default.createElement(
        'div',
        { style: { display: 'inline-block' } },
        _react2.default.createElement(_components.EnterpriseInput, {
          type: 'text',
          onChange: this.handleChange,
          value: value,
          placeholder: 'VALUE',
          className: _InputValueEditor2.default.mono
        })
      );
    }
  }]);
  return InputValueEditor;
}(_react.Component);

exports.default = InputValueEditor;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/InputValueEditor/InputValueEditor.jsx
// module id = 1456
// module chunks = 0